import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn, Field, inputCls } from "./ui";

export const CourtesyDialog = ({ c, onClose, onDone }) => {
  const [days, setDays] = useState(1);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/clients/${c.id}/courtesy`, { days: parseInt(days, 10) });
      toast.success(`+${days} dia(s) de cortesia`);
      onDone(data.client);
    } catch (e) { toast.error(e.response?.data?.detail || "Falha na cortesia"); onDone(null); }
    setBusy(false);
  };
  return (
    <Modal testid="courtesy-dialog" title="Dias de cortesia" onClose={onClose}>
      <p className="mb-3 text-xs text-slate-400">Não consome créditos. O SYSLOG só aceita para clientes que vencem em até 3 dias.</p>
      <Field label="Dias (1 a 365)">
        <input data-testid="courtesy-days" type="number" min={1} max={365} value={days} onChange={(e) => setDays(e.target.value)} className={inputCls} />
      </Field>
      <div className="mt-5 flex justify-end gap-2">
        <Btn tone="ghost" onClick={onClose}>Cancelar</Btn>
        <Btn data-testid="courtesy-confirm" disabled={busy} onClick={go}>Adicionar</Btn>
      </div>
    </Modal>
  );
};
